import _ from "lodash";
import ls from "local-storage";
import Axios from 'axios';

const saveTravelPlansSmartList = async customs => {
    try {
        await Axios.post('/userclientconfigurations', {
            Name: 'travelplan-smart-list',
            JsonData: JSON.stringify({
                smartList: customs
            })
        });
    } catch (error) {
        console.error('Save TravelPlans Smart List Error => ', error);
    }
};

const TravelPlanFiltersReducer = (state, action) => {
    switch (action.type) {
        case "TravelPlanFiltersChangeActiveSet":
            ls.set("nw_config_travelplanwallfilter", {
                ...state,
                activeSet: action.newActiveSet,
                filterType: action.filterType
            });
            return {
                ...state,
                activeSet: action.newActiveSet,
                filterType: action.filterType
            };
        case "TravelPlanFiltersAddCustomSet":
            const customSetCopy = Array.isArray(state.customSets) ? [...state.customSets] : [];
            customSetCopy.push(action.newSet);
            const data = {
                ...state,
                customSets: customSetCopy,
                activeSet: action.newSet.id
            }
            ls.set("nw_config_travelplanwallfilter", data);
            let smartList = [...data.customSets];
            saveTravelPlansSmartList(smartList);
            return {
                ...state,
                customSets: customSetCopy,
                activeSet: action.newSet.id
            };
        case "TravelPlanFiltersEditCustomSet":
            let customSetCopy2 = state.customSets.filter(
                el => el.id !== action.newSet.id
            );
            action.newSet.id = Date.now();
            customSetCopy2.push(action.newSet);
            const editData = {
                ...state,
                customSets: customSetCopy2,
                activeSet: action.newSet.id
            };
            ls.set("nw_config_travelplanwallfilter", editData);
            let editSmartList = editData.customSets
            saveTravelPlansSmartList(editSmartList);
            return {
                ...state,
                customSets: customSetCopy2,
                activeSet: action.newSet.id
            };
        case "TravelPlanFiltersCloneSet":
            const copyOfActive = _.cloneDeep(action.activeSet);
            copyOfActive.id = Date.now();
            copyOfActive.fixed = false;
            copyOfActive.name = copyOfActive.name + "(copy)";
            const copyOfCustomSets = [...state.customSets];
            copyOfCustomSets.push(copyOfActive);
            const cloneData = {
                ...state,
                customSets: copyOfCustomSets,
                activeSet: copyOfActive.id
            };
            ls.set("nw_config_travelplanwallfilter", cloneData);
            let cloneSmartList = [...cloneData.customSets];
            saveTravelPlansSmartList(cloneSmartList);
            return {
                ...state,
                customSets: copyOfCustomSets,
                activeSet: copyOfActive.id
            };
        case "TravelPlanFiltersDeleteSet":
            const newCustomSets = [...state.customSets].filter(
                el => el.id !== action.activeSet
            );
            const deleteData = {
                ...state,
                customSets: newCustomSets,
                activeSet: 'v1'
            };
            ls.set("nw_config_travelplanwallfilter", deleteData);
            let deleteSmartList = [...deleteData.customSets];
            saveTravelPlansSmartList(deleteSmartList);
            return {
                ...state,
                customSets: newCustomSets,
                activeSet: 'v1'
            };
        case "TravelPlanSaveCustomSets":
            let newFilterData = { ...state, customSets: action.customSets };
            ls.set("nw_config_travelplanwallfilter", newFilterData);
            return newFilterData;
        default:
            return state;
    }
};

export default TravelPlanFiltersReducer;
